module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M15.912 8.894a7.017 7.017 0 1 1-7.018 7.016 7.017 7.017 0 0 1 7.018-7.016z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/nutritive-highlight.js
// module id = 1313
// module chunks = 14